import React, { Component } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";

import HomeUrl from '../assets/images/home-border.png';
import Feature from '../assets/images/features/img-3.png';

export default class Contact extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section" id="contact">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="title-box text-center">
                  <h3 className="title-heading mt-4">Let’s Discuss Your Project</h3>
                  <p className="text-muted f-17 mt-3">
                    We’re here to help you take your business to the next level. Whether you need a website, app, or a complete digital strategy, our team is ready to discuss your ideas.
                  </p>
                  <img src={HomeUrl} height="15" className="mt-3" alt="decorative border" />
                </div>
              </Col>
            </Row>
            <Row className="mt-5 pt-4">
              <Col lg={6}>
                <div className="mt-4 home-img text-center">
                  <img src={Feature} className="img-fluid" alt="Contact illustration" style={{ borderRadius: '8px' }} />
                </div>
              </Col>
              <Col lg={6}>
                <div className="custom-form mt-4">
                  <Form method="post" name="contact-form" id="contact-form">
                    <Row>
                      <Col lg={6}>
                        <FormGroup className="mt-3">
                          <Label className="contact-label">First Name</Label>
                          <Input name="firstName" id="firstName" className="form-control" type="text" placeholder="Enter your first name" />
                        </FormGroup>
                      </Col>
                      <Col lg={6}>
                        <FormGroup className="mt-3">
                          <Label className="contact-label">Last Name</Label>
                          <Input name="lastName" id="lastName" className="form-control" type="text" placeholder="Enter your last name" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <FormGroup className="mt-3">
                          <Label className="contact-label">Email Address</Label>
                          <Input name="email" id="email" className="form-control" type="email" placeholder="Enter your email address" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <FormGroup className="mt-3">
                          <Label className="contact-label">Your Message</Label>
                          <Input type="textarea" name="message" id="message" rows="5" className="form-control" placeholder="How can we help you?" />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} className="mt-3 text-right">
                        <Input
                          id="submit"
                          name="send"
                          color="primary"
                          className="submitBnt btn btn-primary btn-round"
                          value="Send Message"
                          type="submit"
                          style={{
                            width: 'auto',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            padding: '10px 20px',
                            borderRadius: '25px',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                        />
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
